module.exports = __webpack_public_path__ + "img/fengxian.77e37d34.png";